module.exports = __webpack_public_path__ + "resources/img/img-hyper-frame-apache-01-en.b92c120105f5234dfe706ed04e9bb350.png";